import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import PayButton from '../../../components/PayButton';
import {orderToPay} from '../../../redux/selectors/order';
import './tips.scss';
import FormattedPrice from '../../../components/FormattedPrice';
import {setClientTips, setClientTipType, submitWebPayment} from '../../../redux/actions/webPayActions';
import IPosModal from '../../../IPosModal';
import {withTranslation} from 'react-i18next';

const Tips = ({
                clientPaymentAmount,
                branchInfo,
                setClientTipType,
                clientTipType,
                clientTips,
                submitWebPayment,
                setClientTips,
                t
              }) => {
  const history = useHistory();
  // const [selectedTip, setSelectedTip] = useState(clientTips);
  const [showManualInput, setShowManualInput] = useState(clientTipType && clientTipType.key === 'manual');
  const {branchId, orderId} = useParams();

  const tipsAbilities = [
    {key: '10', value: 0.1},
    {key: '12', value: 0.12},
    {key: '15', value: 0.15},
    {key: '20', value: 0.2},
    {key: 'no', value: 0},
    {key: 'manual', value: -1}
  ];

  const onPayClick = async () => {
    history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}/credit-card`);
  };

  const onSelectTips = (tip) => {
    if (clientTipType && tip.key === 'manual') {
      setClientTipType(tip);
      setClientTips(null);
    } else {
      setClientTipType(tip);
    }
  };

  const handleManualTip = (e) => {
    const {value} = e.currentTarget;
    if (value === '' || /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(value)) {
      if (parseFloat(value) >= 0 || value.trim() === '') {
        setClientTips(value);
      }
    }
  };

  useEffect(() => {
    if (!clientTipType) {
      setShowManualInput(false);
      return;
    }
    if (clientTipType.key === 'manual') {
      //setClientTips(null);
      setShowManualInput(true);
      return;
    } else {
      setShowManualInput(false);
    }

    if (clientTipType.key === 'no') {
      setClientTips(null);
      return;
    }

    setClientTips((clientPaymentAmount / 100) * + clientTipType.value);
  }, [clientTipType]);

  // useEffect(() => {
  //   if (clientTipType && clientTipType.key === 'manual') {
  //     setClientTips(null);
  //   }
  // }, [showManualInput]);

  return (
    <div className={ 'tips-page' }>
      <div className={ 'tips-block' }>
        <div className={ 'list-label' }>{t('web_pay.tips.title')}</div>
        <div className={ 'tips-list' }>
          {
            tipsAbilities.map(tip => (
              <div
                className={ `tip-method ${tip.key} ${clientTipType && tip.key === clientTipType.key ? 'selected' : ''}` }
                onClick={ () => {
                  onSelectTips(tip);
                } }
              >
                {t(`web_pay.tips.tips_options.${tip.key}`)}
              </div>
            ))
          }
        </div>
        {showManualInput && (
          <div className={ 'manual-tips' }>
            <input
              type="tel"
              name="phone"
              className="phone-input"
              maxLength={ 10 }
              autoComplete={"off"}
              placeholder={ t('web_pay.tips.manual_tips_placeholder') }
              onChange={ handleManualTip }
              value={ clientTips }
            />
          </div>
        )}
      </div>

      <div className={ 'selected-tips' }>
        <div className={ 'caption' }>{t('web_pay.tips.amount')}</div>
        <div className={ 'value' }>
          <FormattedPrice price={ clientPaymentAmount } />
        </div>
      </div>
      <div className={ 'selected-tips' }>
        <div className={ 'caption' }>{t('web_pay.tips.tips_amount')}</div>
        <div className={ 'value' }>
          <FormattedPrice price={ (clientTips || 0) * 100 } />
        </div>
      </div>

      <div className="actions">
        {/*<div*/}
        {/*  className="btn back" onClick={ () => {*/}
        {/*  history.goBack();*/}
        {/*} }>*/}
        {/*  Cancel*/}
        {/*</div>*/}
        <PayButton
          price={ clientPaymentAmount + ((clientTips || 0) * 100) }
          text={ t('web_pay.buttons.pay') }
          disabled={ !clientTipType || (clientTipType && clientTipType.key === 'manual' && (!clientTips || +clientTips === 0)) }
          onClick={ onPayClick }
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo,
    clientPaymentData,
    clientTips,
    clientPaymentAmount,
    clientTipType
  } = state;

  return {
    branchInfo,
    clientPaymentData,
    clientTips,
    clientPaymentAmount,
    clientTipType,
    toPayAmount: orderToPay(state)    
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitWebPayment,
      setClientTipType,
      setClientTips
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Tips));

